<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.status" multiple collapse-tags placeholder="销售状态" @visible-change="getSelectWarehouseList('status')">
                    <el-option v-for="(list,index) in selectMapC.status" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" @keyup.enter.native="getList(true)" placeholder="捆包号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectWarehouseList('brand_id')">
                    <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.pieces" multiple collapse-tags placeholder="片数" @visible-change="getSelectWarehouseList('pieces')">
                    <el-option v-for="(list,index) in selectMapC.pieces" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectWarehouseList('original_thickness')">
                    <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                    <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.bale_status" multiple collapse-tags placeholder="资源状态" @visible-change="getSelectWarehouseList('bale_status')">
                    <el-option v-for="(list,index) in selectMapC.bale_status" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.contract_no" placeholder="采购合同号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.finance_order_sn" placeholder="融资提单号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.container_no" placeholder="货柜号"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                
                <!-- <div class="upimgBtnBox" v-if="module.indexOf(',purchase-upload-files,')!=-1" @click="bacthUpFile">
                    <div class="upFileBtnImg"></div>
                    <div class="upimgBtnTitle">上传文件</div>
                </div> -->
            </div>
            <div class="tableBox">
                <tabletem :isShowIndex="true" :isSetCol="true" scene="pledge.stock.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @relativefile="relativeFile" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalName">合计：</div>
                <div class="totalNumber">融资件数: {{tot.finance_count}}件</div>  
                <div class="totalNumber">融资方数: {{tot.finance_cube}}m³</div>      
                <div class="totalNumber">融资货值: {{tot.finance_amount}}</div>
                <div class="totalNumber">融资费用: {{tot.finance_fee}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="pledge.stock.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 融资成本明细 START -->
        <el-dialog v-dialog-drag :visible.sync="costLogDetailDialog" class="eldialog specTable"
                width="490px" :modal="false" :title="'融资成本明细'" custom-class="full_dialog">
            <div class="tableBox" style="min-height: 250px;max-height: 400px">
                <tabletem :isShowIndex="true" :is-hide-checkout="false" :isHideColumn="false" :is-align-center="true"  :tablecol="costLogDetailTableCol" :tabledata="costLogDetailList">
                </tabletem>
            </div>
            <div style="padding: 5px;font-size: 15px;text-align: left;">
                合计  平摊金额:{{costLogtotal.amount}}
            </div>
            <!-- <div class="costLogBottomBtn" style="padding: 10px 0 0;">
                <el-button type="primary" @click="costLogDetailDialog=false">我知道了</el-button>
            </div> -->
        </el-dialog>
    </div>
</template>
<script>
    import tabletem from '../../../components/table.vue';
    import pagination from '../../../components/pagination.vue';

    export default {
        data() {
            return {
                module:localStorage.dw_erp_power_code,
                statistical:{},
                params:{
                    supplier_id:"",
                    supplier:this.supplierName,
                    breed:"",
                    brand:"",
                    grade:"",
                    sales_length:"",
                    sales_thickness:"",
                    sales_width_total:"",
                    inventory_province:"",
                    inventory_city:"",
                    warehouse:"",
                    bale_no:"",
                    page:1,
                    per_page:50,
                },
                last_page:1,
                total:0,
                tot:{},
                selectRow:[],
                list:[],
                filter:"",
                fields:"",
                filterDialogVisible:false,
                tableCol:[
                    {colName:"销售状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"index_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"index_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"资源状态",colKey:"finance_bale_status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购合同号",colKey:"contract_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资提货单",colKey:"finance_order_sn",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"发票号",colKey:"invoice_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资费用平摊单价",colKey:"finance_cost",colWidth:80,isCanClick:true,isPopout:true,isHideShowClickImg:true,isColor:true},
                    {colName:"融资成本单价",colKey:"finance_cost_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资利息",colKey:"pay_interest",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                tableLoading:false,
                start_time:"",
                end_time:"",
                selectMap:{},
                isShowMore:false,
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    status:[],
                    bale_status:[],
                    pieces:[],
                    status_text:[],
                },
                costLogDetailDialog:false,
                costLogDetailList:[],
                costLogtotal:{},
                costLogDetailTableCol:[
                    {colName:"平摊日期",colKey:"fee_date",isDate:true,},
                    {colName:"费用类型",colKey:"fee_name"},
                    {colName:"平摊金额",colKey:"amount"},
                    {colName:"操作人",colKey:"creator_name"},
                ],
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getSelectWarehouseList(target){
                this.params.types= 'finance';
                this.$getSelectWarehouseList(target,this.params,"","finance").then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            getList(){
                this.tableLoading = true;
                // this.params.search.start_time=this.formatTimeZero(this.start_time);
                // this.params.search.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/pledge.stock.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.tot= res.data.data.total;
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTime(item.inbound_time+"000")
                        }else{
                            this.list[index].inbound_time = "";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
            },
            filterConfirm(){
                this.getList()
            },
            rowClick(obj){
                if(obj.name =='finance_cost'){
                    this.postFunc('/erp/finance.cost.logs',{inventory_id:obj.id},res=>{
                        this.costLogDetailDialog = true;
                        let resD = res.data.data.data;
                        this.costLogDetailList.forEach((item,index)=>{
                           this.costLogDetailList[index].fee_date = this.formatTime(item.fee_date+"000");
                        })
                        this.costLogDetailList = Array.isArray(resD) ? resD : [];
                        this.costLogtotal = res.data.data.total;
                    })
                }
            },
            //合计
            getTableSummaries(params) {
                return this.$setSummaryFields(params,{
                    amount:2,
                    },total=>{
                });
            },
            reset(){
                this.params=this.resetSearch(this.params)
                // this.start_time="";
                // this.end_time="";
                this.getList();
            },
            relativeFile(obj){
                // this.downLoadFileDialog = !this.downLoadFileDialog;
                // this.downFilesList = obj.files;
            },
            excelExport(){
                this.$exportExecl("/erp/pledge.stock.export","融资库存",this.params)
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "isShowEditfinance":function(val){
                if(!val){
                    this.feeForm={}
                }
            }
        },
    }
</script>
<style scoped lang="scss">
    .banking_box {
        background-color: #fff;
        margin: 5px 0 0 5px;
        .show {
            display: flex;
            padding: 10px;
            margin-bottom: 2px;

            .item {
                flex: 1;
                display: flex;
                align-items: center;
                height: 100px;
                margin-right: 10px;
                box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
                border-radius: 6px;
                padding: 0 10px;

                .left_icon {
                    flex: 1;
                    text-align: left;

                    .top {
                        font-size: 18px;
                        color: #000;
                        /*font-weight: 500;*/
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .icon_item {
                            width: 26px;
                            height: 26px;
                            background-size: contain !important;
                            background-clip:content-box !important;
                            margin-right: 10px;
                        }
                        // .fi_order_num{background:url(../../../assets/finance/fi_order_num.png) no-repeat;}
                        // .fi_cube{background:url(../../../assets/finance/fi_cube.png) no-repeat;}
                        // .fi_amount{background:url(../../../assets/finance/fi_amount.png) no-repeat;}
                        // .fi_interest{background:url(../../../assets/finance/fi_interest.png) no-repeat;}
                        // .fi_ensure_amount {background: url(../../../assets/finance/fi_ensure_amount.png) no-repeat;}
                        // .fi_alert {background: url(../../../assets/finance/fi_alert.png) no-repeat;}
                    }

                    .bottom {
                        margin-top: 15px;
                        font-size: 26px;
                        text-align: center;
                        /*font-weight: 700;*/
                    }

                }


            }
        }
        .depositButton{background-color: #F9A602;color: #fff;padding: 8px 20px;float: left;margin-right: 15px;}

        .total {
            display: flex;
            margin: 2px 0;
            font-size: 14px;
            color: #000;

            .total_left {
                flex-basis: 60px;
                background-color: #fff;
                margin-right: 2px;
                padding: 10px;
                font-weight: 600;
            }

            .total_right {
                flex: 1;
                background-color: #fff;
                padding: 10px;
                text-align: left;

                span {
                    font-weight: 600;
                    margin-right: 20px;
                }
            }
        }

        .pag_box {
            background-color: #fff;
        }
    }
    // .specTable >>> .el-dialog__body{padding:0;border-radius: 0 0 5px 5px;overflow: hidden;}
    // .specTable >>> .el-table .cell.el-tooltip{text-align: center;}
    // .specTable >>> .el-table th>.cell{text-align: center;}
    // .fiFiles{text-align: left;height:35px;}
    // .fiFiles /deep/ .el-upload-list--picture-card .el-upload-list__item{
    //     width:55px;
    //     height: 35px;
    // }
    // .fiFiles /deep/ .el-upload.el-upload--picture-card{
    //     width:55px;
    //     height: 35px;
    //     line-height: 35px;
    // }
    // .fiFiles /deep/ .el-upload-list--picture-card .el-upload-list__item-actions span + span{
    //     margin-left: 5px;
    // }
    // .fiFiles /deep/ .el-upload.el-upload--picture-card .el-button.el-button--small{
    //     font-size: 8px;
    //     padding: 2px 5px;
    // }
    // .fiFiles /deep/ .el-upload--picture-card i{
    //     font-size: 18px;
    // }
    // .fiFiles /deep/ .el-upload-list__item.is-success:focus:not(:hover) .el-icon-close-tip{
    //     display: none;
    // }
    // .eldialog.payForm /deep/ .formInput{
    //     width:190px;
    // }
    // .eldialog.payForm /deep/ .formSpan{
    //     display: inline-block;
    //     width: 190px;
    //     font-size: 12px;
    //     text-align: left;
    //     padding-left: 5px;
    //     box-sizing: border-box;
    // }
    // .eldialog.payForm /deep/ .el-form-item--mini.el-form-item{
    //     margin-bottom: 7px;
    // }

    // /deep/ .checkVerifyDialog{
    //     margin-top: 20vh !important;
    //     .checkVerifyBox{
    //         display: flex;
    //         flex-direction: column;
    //         justify-content: center;
    //         align-items: center;
    //         padding: 20px;
    //         .bankImg{
    //             width: 122px;
    //             height: 66px;
    //         }
    //         .contDiv{
    //             margin-top: 20px;
    //             font-size: 12px;
    //             .linkToFi{
    //                 color: #408DF6;
    //                 text-decoration: underline;
    //             }
    //         }
    //         .closeDiv{
    //             margin-top: 50px;
    //             .checkVerifyCloseBtn{
    //                 padding: 10px 30px;
    //                 color: #000;
    //                 border-color: #777;
    //             }
    //         }

    //     }

    // }
</style>